// 1
import col1 from "../image/col1.jpg";
import col1_1 from "../image/col1-1.webp";
import col1_2 from "../image/col1-2.jpg";
import col1_3 from "../image/col1-3.jpg";
import col1_4 from "../image/col1-4.jpg";
import col1_5 from "../image/col1-5.jpg";
import col1_6 from "../image/col1-6.jpg";
import col1_7 from "../image/col1-7.jpg";
import col1_8 from "../image/col1-8.webp";
import col1_9 from "../image/col1-9.webp";

// 2
import col2 from "../image/col2.webp";
import col2_1 from "../image/col2-1.webp";
import col2_2 from "../image/col2-2.jpg";
import col2_3 from "../image/col2-3.jpg";
import col2_4 from "../image/col2-4.webp";
import col2_5 from "../image/col2-5.jpg";
import col2_6 from "../image/col2-6.webp";
import col2_7 from "../image/col2-7.jpg";
import col2_8 from "../image/col2-8.webp";

// 3
import col3 from "../image/col3.webp";
import col3_1 from "../image/col3-1.jpg";
import col3_2 from "../image/col3-2.jpg";
import col3_3 from "../image/col3-3.jpg";
import col3_4 from "../image/col3-4.jpg";
import col3_5 from "../image/col3-5.webp";
import col3_6 from "../image/col3-6.webp";
import col3_7 from "../image/col3-7.webp";
import col3_8 from "../image/col3-8.webp";
import col3_9 from "../image/col3-9.webp";
import col3_10 from "../image/col3-10.webp";

// 4
import col4 from "../image/col4.jpg";
import col4_1 from "../image/col4-1.jpg";
import col4_2 from "../image/col4-2.jpg";
import col4_3 from "../image/col4-3.jpg";
import col4_4 from "../image/col4-4.jpg";
import col4_5 from "../image/col4-5.jpg";
import col4_6 from "../image/col4-6.webp";
import col4_7 from "../image/col4-7.webp";
import col4_8 from "../image/col4-8.webp";
// 5
import col5 from "../image/col5.webp";
import col5_1 from "../image/col5-1.webp";
import col5_2 from "../image/col5-2.webp";
import col5_3 from "../image/col5-3.webp";
import col5_4 from "../image/col5-4.jpg";
import col5_5 from "../image/col5-5.webp";
import col5_6 from "../image/col5-6.webp";
import col5_7 from "../image/col5-7.jpg";
import col5_8 from "../image/col5-8.webp";

// 6
import col6 from "../image/col6.webp";
import col6_1 from "../image/col6-1.jpg";
import col6_2 from "../image/col6-2.webp";
import col6_3 from "../image/col6-3.jpg";
import col6_4 from "../image/col6-4.webp";
import col6_5 from "../image/col6-5.webp";
import col6_6 from "../image/col6-6.jpg";
import col6_7 from "../image/col6-7.jpg";

// 7
import col7 from "../image/col7.jpg";
import col7_1 from "../image/col7-1.jpg";
import col7_2 from "../image/col7-2.jpg";
import col7_3 from "../image/col7-3.jpg";
import col7_4 from "../image/col7-4.jpg";
import col7_5 from "../image/col7-5.jpg";
import col7_6 from "../image/col7-6.jpg";
import col7_7 from "../image/col7-7.webp";
import col7_8 from "../image/col7-8.webp";
// 8
import col8 from "../image/col8.webp";
import col8_1 from "../image/col8-1.webp";
import col8_2 from "../image/col8-2.jpg";
import col8_3 from "../image/col8-3.jpg";
import col8_4 from "../image/col8-4.webp";
import col8_5 from "../image/col8-5.webp";
import col8_6 from "../image/col8-6.webp";
import col8_7 from "../image/col8-7.webp";

// 9
import col9 from "../image/col9.jpg";
import col9_1 from "../image/col9-1.jpg";
import col9_2 from "../image/col9-2.jpg";
import col9_3 from "../image/col9-3.jpg";
import col9_4 from "../image/col9-4.jpg";
import col9_5 from "../image/col9-5.jpg";
import col9_6 from "../image/col9-6.jpg";

// 10
import col10 from "../image/col10.webp";
import col10_1 from "../image/col10-1.webp";
import col10_2 from "../image/col10-2.webp";
import col10_3 from "../image/col10-3.webp";
import col10_4 from "../image/col10-4.webp";
import col10_5 from "../image/col10-5.webp";
import col10_6 from "../image/col10-6.webp";
import col10_7 from "../image/col10-7.webp";

// 11
import col11 from "../image/col11.webp";
import col11_1 from "../image/col11-1.webp";
import col11_2 from "../image/col11-2.webp";
import col11_3 from "../image/col11-3.webp";
import col11_4 from "../image/col11-4.webp";
import col11_5 from "../image/col11-5.webp";
import col11_6 from "../image/col11-6.webp";
import col11_7 from "../image/col11-7.webp";

// 12
import col12 from "../image/col12.jpg";
import col12_1 from "../image/col12-1.jpg";
import col12_2 from "../image/col12-2.jpg";
import col12_3 from "../image/col12-3.jpg";
import col12_4 from "../image/col12-4.webp";
import col12_5 from "../image/col12-5.webp";
import col12_6 from "../image/col12-6.webp";
import col12_7 from "../image/col12-7.webp";
import col12_8 from "../image/col12-8.webp";

// 13
import col13 from "../image/col13.webp";
import col13_1 from "../image/col13-1.webp";
import col13_2 from "../image/col13-2.webp";
import col13_3 from "../image/col13-3.webp";
import col13_4 from "../image/col13-4.webp";
// 14
import col14 from "../image/col14.webp";
import col14_1 from "../image/col14-1.webp";
import col14_2 from "../image/col14-2.webp";
import col14_3 from "../image/col14-3.webp";
import col14_4 from "../image/col14-4.webp";
import col14_5 from "../image/col14-5.webp";

// 15
import col15 from "../image/col15.webp";
import col15_1 from "../image/col15-1.webp";
import col15_2 from "../image/col15-2.webp";
import col15_3 from "../image/col15-3.webp";
import col15_4 from "../image/col15-4.webp";
import col15_5 from "../image/col15-5.webp";
// 16
import col16 from "../image/col16.jpg";
import col16_1 from "../image/col16-1.jpg";
import col16_2 from "../image/col16-2.jpg";
import col16_3 from "../image/col16-3.jpg";
import col16_4 from "../image/col16-4.webp";
// 17
import col17 from "../image/col17.webp";
import col17_1 from "../image/col17-1.jpg";
import col17_2 from "../image/col17-2.jpg";
import col17_3 from "../image/col17-3.webp";
// 18
import col18 from "../image/col18.jpg";
// 19
import col19 from "../image/col19.jpg";
// 20
import col20 from "../image/col20.webp";

export const productList = [
  {
    category: "Bobi",
    list: [
      {
        id: 1,
        title: "Mr. Grumpy Leather Slippers",
        quantity: 1,
        image: [
          col1,
          col1_1,
          col1_2,
          col1_3,
          col1_4,
          col1_5,
          col1_6,
          col1_7,
          col1_8,
        ],
        price: 147,
        total: 147,
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "black", "blue", "cowhide", "red wine"],
          },
        ],
        checked: "olive",
        descript: [
          "Give a gift to your feet with our Mr. Grumpy slippers. The leather lining and cushioned heel allow for extra comfort - especially as they break in and adjust to the contours of your feet. Great for going outside and yelling at kids to get off your lawn. This is a limited-size run. We suggest sizing up if in doubt. ",
          "Rubber outsole for indoor/outdoor use",
          "Materials and specs",
          "Made with leather and suede.",
        ],
      },
      {
        id: 2,
        title: "The Cargo Tote Bag",
        quantity: 1,
        image: [col2, col2_1, col2_2, col2_3, col2_4, col2_5, col2_6, col2_7],
        price: 334,
        total: 334,
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["tan", "black", "chocolate"],
          },
        ],
        checked: "tan",
        descript: [
          "Our Cargo Tote Bag strikes the perfect balance between form and function to create a dependable everyday tote bag. This bag offers plenty of capacity with an external and an internal drop pocket. Perfect for the weekend getaway or pulling double duty as a work tote to hold electronics, books, or tools. Sturdy full-grain leather construction ensures this tote lasts a very long time and gains character with age and use.",
          "Made from premium full-grain leather that develops a rich patina",
          "Roomy interior fits a laptop, water bottle, and daily gear",
          "Lifetime Guarantee",
          "Materials and specs",
          "Made with Full-Grain Leather.",
          '• Width: 13.5" at base, 21" across the top',
          '• Height: 13.75"',
          '• Depth: 4.25"',
          '• Handle drop: 10.5"',
          "• Weight: 2.8lbs",
        ],
      },
      {
        id: 3,
        title: "The Wine Tote",
        quantity: 1,
        image: [col3, col3_1, col3_2, col3_3, col3_4],
        price: 125,
        total: 125,
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["tan", "black"],
          },
        ],
        checked: "tan",
        descript: [
          "One is the loneliest number. Our leather wine tote carries two bottles of your wine with ease and style. Made with full-grain strap leather and woven together to create the perfect pairing to your grapes. A corkscrew pouch is included (which can also be monogrammed to make a great gift for the wine lovers in your life).",
          "Materials and specs",
          "Made with Full-Grain Leather",
          '• Width: 9"',
          '• Height: 13.5"',
          '• Depth: 3.5"',
        ],
      },
      {
        id: 4,
        title: "The Sling Bag",
        quantity: 1,
        image: [col4, col4_1, col4_2, col4_3, col4_4],
        price: 193,
        total: 193,
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["tan", "black", "olive"],
          },
        ],
        checked: "tan",
        descript: [
          `Introducing The Sling Bag – a fusion of style and function. Crafted from durable full-grain leather, it ages gracefully, gaining character over time. With external pockets and an adjustable strap, it's perfect for daily adventures. The Sling Bag is designed in the perfect size, offering both convenience and style for your on-the-go needs.`,
          "Materials and specs",
          "Full-Grain leather and solid brass hardware.",
          'Main Compartment: 9" x 6" x 2"',
          'Strap: Adjustable from 29"-48"',
        ],
      },
    ],
  },
  {
    category: "Léon",
    list: [
      {
        id: 5,
        title: "The Oversized Leather Tote",
        quantity: 1,
        image: [col5, col5_1, col5_2, col5_3, col5_4, col5_5, col5_6, col5_7],
        price: 322,
        total: 322,
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "chocolate", "black"],
          },
        ],
        checked: "olive",
        descript: [
          "The bigger the tote, the better. Our oversized tote makes sure you can fit everything you could possibly need for work or travel. Laptops, water bottles, books - you name it, this leather tote can take it on. The Oversized is made with our full-grain leather that is soft, but sturdy. The solid bottom helps this tote keep its shape day in and day out. An accessory strap with solid brass hardware is included.",
          "Materials and specs",
          "Made with 100% Full-Grain Leather",
          "and solid brass Hardware.",
          '• Width: 18.25"',
          '• Height: 13"',
          '• Depth: 5.75"',
          '• Handle drop: 10.5"',
          "• Weight: 2.5lbs.",
        ],
      },
      {
        id: 6,
        title: "PanAm Duffle Bag",
        quantity: 1,
        image: [col6, col6_1, col6_2, col6_3, col6_4, col6_5, col6_6, col6_7],
        price: 562,
        total: 562,
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["chocolate", "olive", "tan", "black"],
          },
        ],
        checked: "chocolate",
        descript: [
          `The Pan Am Duffle Bag is the perfect companion for your next weekend getaway or round-the-world trip. It's made from full-grain leather and features an adjustable strap, luggage tag, and a heavy-duty 2-way zipper. It comes with a lifetime guarantee - so you can count on it to last through your many journeys.`,
          "Materials and specs",
          "Made with Full-Grain leather and solid brass hardware.",
          '• Width: 21"',
          '• Height: 10"',
          '• Depth: 10"',
          "• Weight: 5.5lbs",
        ],
      },
      {
        id: 7,
        title: `Traveler's Laptop Sleeve`,
        quantity: 1,
        image: [col7, col7_1, col7_2, col7_3, col7_4, col7_5, col7_6],
        price: 155,
        total: 155,
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["chocolate", "olive", "tan", "black"],
          },
        ],
        checked: "chocolate",
        descript: [
          `Our leather laptop sleeve provides heavy-duty protection for your laptop day in and day out. We use our full-grain leathers and line the interior padding with a soft quilted lining that is gentle on your laptop's surface. Internal pockets for chargers and pens make this a handsome carry-all for your tech essentials.`,
          "Materials and specs",
          "Made with Full-Grain leather.",
          '• 13"-14" Laptops - 14" x 10" x 1"',
          '• 15"-16" Laptops - 16" x 11" x 1"',
        ],
      },
      {
        id: 8,
        title: `Zip Around Wallet`,
        quantity: 1,
        image: [col8, col8_1, col8_2, col8_3, col8_4, col8_5],
        price: 137,
        total: 137,
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["chocolate", "olive", "tan", "black"],
          },
        ],
        checked: "chocolate",
        descript: [
          `The Zip Around Wallet's classic design carries cards, cash, and more in our signature full-grain leathers. `,
          "Materials and specs",
          "Made with Full-Grain Leather.",
          '• 8" wide x 5" tall (closed)',
        ],
      },
    ],
  },
  {
    category: "Lulu",
    list: [
      {
        id: 9,
        title: "Traveler's Laptop Sleeve",
        quantity: 1,
        price: 155,
        total: 155,
        image: [col9, col9_1, col9_2, col9_3, col9_4, col9_5, col9_6],
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "chocolate", "black"],
          },
        ],
        checked: "olive",
        descript: [
          `Our leather laptop sleeve provides heavy-duty protection for your laptop day in and day out. We use our full-grain leathers and line the interior padding with a soft quilted lining that is gentle on your laptop's surface. Internal pockets for chargers and pens make this a handsome carry-all for your tech essentials.`,
          "Materials and specs",
          "Made with Full-Grain leather.",
          '• 13"-14" Laptops - 14" x 10" x 1"',
          '• 15"-16" Laptops - 16" x 11" x 1"',
        ],
      },
      {
        id: 10,
        title: "Slim Laptop Sleeve",
        quantity: 1,
        price: 115,
        total: 115,
        image: [col10, col10_1, col10_2],
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["tan", "chocolate", "black"],
          },
        ],
        checked: "tan",
        descript: [
          "A simpler way to carry. The Studio Laptop Sleeve is built for those who prefer less bulk — a clean, no-zipper, no-padding design that slips easily into a bag or under your arm. Hand-crafted from full-grain leather, it will develop a rich patina with use, telling its own story over time.",
          "Designed for the office, studio, or anywhere in between, it’s proof that sometimes the simplest tools are the best.",
          "Materials and specs",
          "Made with full-grain leather.",
          '13" Version: 14" x 10" x .5" and fits a 13" laptop.',
          '16" Version: 16" x 11" x .5" and fits both 15" and 16" laptops.',
        ],
      },
      {
        id: 11,
        title: "The Gadget Bag",
        quantity: 1,
        price: 78,
        total: 78,
        image: [col11, col11_1, col11_2, col11_3, col11_4],
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "chocolate", "black"],
          },
        ],
        checked: "olive",
        descript: [
          `Our Gadget Bag is a compact, durable solution for organizing your gear. Built from premium leather with a sturdy zip closure, it’s perfect for stashing in your backpack, duffle, or desk drawer. Whether you're on the road or just tired of tangled cables, this little bag keeps your everyday tech tidy and close at hand.`,
          "Materials and specs",
          "Made from full-grain leather.",
          '7" x 4" x 2"',
        ],
      },
      {
        id: 12,
        title: "The Utility Pouches",
        quantity: 1,
        price: 88,
        total: 88,
        image: [col12, col12_1, col12_2, col12_3],
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "chocolate", "black"],
          },
        ],
        checked: "olive",
        descript: [
          "These pouches are great for storing all the stuff in your bag that may tend to roll around at the bottom. Chargers, pens, chapstick, and coins. These are a set of 3 that come in 3 different sizes. Keep them all or give them away as gifts to 3 different sized friends.",
          "Materials and specs",
          "Made with Full-Grain Leather.",
          '• Small: 4.25" × 5.5"',
          '• Medium: 4.75" × 6.25"',
          '• Large: 5.25" × 7.25"',
        ],
      },
      {
        id: 17,
        title: "The Contigo Tote Bag",
        quantity: 1,
        price: 246,
        total: 246,
        image: [col17, col17_1, col17_2, col17_3],
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "chocolate", "black"],
          },
        ],
        checked: "black",
        descript: [
          "The Contigo tote is a beautiful workhorse. Crafted from full-grain leather, this bag is designed to carry all you need and get better with each passing season. The double-reinforced base and internal zipper pocket keep your items safe and secure.",
          "Materials and specs",
          "Made with Full-grain Leather.",
          '• Width: 15"',
          '• Height: 13"',
          '• Depth: 5.5"',
          '• Handle drop: 10"',
          "• Weight: 2.2lbs",
        ],
      },
      {
        id: 18,
        title: "The Contigo Tote Bag",
        quantity: 1,
        price: 246,
        total: 246,
        image: [col18, col17_1, col17_2, col17_3],
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "chocolate", "black", "Red Red Wine"],
          },
        ],
        checked: "Red Red Wine",
        descript: [
          "The Contigo tote is a beautiful workhorse. Crafted from full-grain leather, this bag is designed to carry all you need and get better with each passing season. The double-reinforced base and internal zipper pocket keep your items safe and secure.",
          "Materials and specs",
          "Made with Full-grain Leather.",
          '• Width: 15"',
          '• Height: 13"',
          '• Depth: 5.5"',
          '• Handle drop: 10"',
          "• Weight: 2.2lbs",
        ],
      },
      {
        id: 19,
        title: "The Contigo Tote Bag",
        quantity: 1,
        price: 246,
        total: 246,
        image: [col19, col17_1, col17_2, col17_3],
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "chocolate", "black"],
          },
        ],
        checked: "olive",
        descript: [
          "The Contigo tote is a beautiful workhorse. Crafted from full-grain leather, this bag is designed to carry all you need and get better with each passing season. The double-reinforced base and internal zipper pocket keep your items safe and secure.",
          "Materials and specs",
          "Made with Full-grain Leather.",
          '• Width: 15"',
          '• Height: 13"',
          '• Depth: 5.5"',
          '• Handle drop: 10"',
          "• Weight: 2.2lbs",
        ],
      },
      {
        id: 20,
        title: "The Contigo Tote Bag",
        quantity: 1,
        price: 246,
        total: 246,
        image: [col20, col17_1, col17_2, col17_3],
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "chocolate", "black"],
          },
        ],
        checked: "chocolate",
        descript: [
          "The Contigo tote is a beautiful workhorse. Crafted from full-grain leather, this bag is designed to carry all you need and get better with each passing season. The double-reinforced base and internal zipper pocket keep your items safe and secure.",
          "Materials and specs",
          "Made with Full-grain Leather.",
          '• Width: 15"',
          '• Height: 13"',
          '• Depth: 5.5"',
          '• Handle drop: 10"',
          "• Weight: 2.2lbs",
        ],
      },
    ],
  },

  {
    category: "You may also like",
    list: [
      {
        id: 13,
        title: "Leather Dopp Kit",
        quantity: 1,
        price: 158,
        total: 158,
        image: [col13, col13_1, col13_2],
        ishover: false,
        descript: [
          `Our leather Dopp Kit is a perfect home for your toiletries while on the road. We used full-grain leather and an easy to clean liner in the event of any toothpaste disasters. Always the economical packers, we've made this bag lean in size so it won't take up too much room in your bag. It also includes an internal zippered pocket for loose Q-tips, razor blades, and the like.`,
          "Materials and specs",
          "Made with full-grain leather",
          "Waterproof lining",
          '10" x 4.25" x 5.5"',
        ],
      },
      {
        id: 14,
        title: "Leather Valet Tray",
        quantity: 1,
        price: 85,
        total: 85,
        image: [col14, col14_1, col14_2, col14_3],
        ishover: false,
        descript: [
          `The Good Luck Valet Tray is made from full-grain leather that develops a rich patina with age and use. Four hand-hammered brass rivets anchor the folded corners, giving the tray its structure without a single stitch showing. At the center, a horseshoe and the words Good Luck are debossed directly into the hide. Because you can't have too much good luck. `,
          "Materials and specs",
          "Made with full-grain leather and hand-hammered brass rivets.",
          '7.5" x 7.5" x 1.5"',
        ],
      },
      {
        id: 15,
        title: "Leather AirPods Case",
        quantity: 1,
        price: 30,
        total: 30,
        image: [col15, col15_1, col15_2, col15_3, col15_4],
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "chocolate", "black"],
          },
        ],
        checked: "olive",
        descript: [
          "Leather case for your Apple AirPods pro. Includes a solid brass d-ring to connect to the accessory strap on your WP Tote bag. Comes in 4 colors. ",
          "Materials and specs",
          "Use this accordion to add info such as Materials, Sizing, Features, Shipping and Returns policies",
        ],
      },
      {
        id: 16,
        title: "Leather Zip Key Pouch",
        quantity: 1,
        price: 41,
        total: 41,
        image: [col16, col16_1, col16_2, col16_3, col16_4],
        ishover: false,
        sku: [
          {
            title: "color",
            list: ["olive", "tan", "chocolate", "black"],
          },
        ],
        checked: "olive",
        descript: [
          "The zip key pouch is a compact wallet that carries a lot without taking up a lot of room. Carry your keys and your cards, cash, and other essentials. Attach to the accessory strap on your WP tote to keep secure and easily accessible.",
          "Materials and specs",
          "Full-grain leather",
          '6.25" x 4.25"',
        ],
      },
    ],
  },
];

export const getProductDetailById = (id) => {
  let product;
  for (const item of productList) {
    product = item.list.find((itemProduct) => itemProduct.id === id);
    if (product) return product;
  }
  return undefined;
};

// find
export const getCategoryList = (type) => {
  let list = productList.find((item) => item.category === type);
  return list;
};
